<template>
  <div
    class="vipcenter"
    :class="[old == 1 ? 'old_vipcenter' : '']"
    v-if="info != null && old != -1"
  >
    <div class="activity" v-if="activitylist.length">
      <swiper ref="myswiper" :options="activitySwiper" style="height: 100%">
        <swiper-slide v-for="(item, index) of activitylist" :key="index">
          <img
            class="main-img"
            :src="item[old == 1 ? 'oldImgurl' : 'imgurl']"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div class="vipcard_content f0" :style="{ color: item.color }">
            <div
              class="tag color-F d-ib ta-c"
              :class="[
                old == 1 ? 'f19 pt2 pb2 pl12 pr12 h-30px' : 'f13 pl10 pr10 h-21px',
                info.vip_level_value > item.levelvalue ? 'bg-t' : ''
              ]"
            >
              {{
                info.vip_level_value == item.levelvalue
                  ? '当前'
                  : info.vip_level_value < item.levelvalue
                  ? '未解锁'
                  : '\n'
              }}
            </div>
            <p class="vip_title fb" :class="[old == 1 ? 'f22 ml18' : 'f18 ml22']">
              {{ item.level }}
            </p>
            <p class="fb" :class="[old == 1 ? 'ml18 f19' : 'ml22 f13']">
              当前累计消费¥{{ parseFloat(info.vip_money) }}
            </p>
            <div class="plan" :class="[old == 1 ? 'ml18 mt18' : 'ml22 mt23']">
              <div class="ws-n">
                <span
                  :class="[old == 1 ? 'f18' : 'f12']"
                  v-if="
                    parseFloat(info.vip_money) != parseFloat(activitylist[index].money) &&
                    info.vip_level_value != item.levelvalue
                  "
                >
                  {{
                    parseFloat(info.vip_money) > parseFloat(activitylist[index].money)
                      ? '已达成该等级'
                      : '再消费¥' +
                        (
                          parseFloat(activitylist[index].money) - parseFloat(info.vip_money)
                        ).toFixed(2) +
                        '即可升级' +
                        activitylist[index].level
                  }}
                </span>
                <span :class="[old == 1 ? 'f18' : 'f12']" v-else>
                  {{
                    parseFloat(info.vip_money) >=
                    parseFloat(
                      activitylist[index < activitylist.length - 1 ? index + 1 : index].money
                    )
                      ? '已达成该等级'
                      : '再消费¥' +
                        (
                          parseFloat(
                            activitylist[index < activitylist.length - 1 ? index + 1 : index].money
                          ) - parseFloat(info.vip_money)
                        ).toFixed(2) +
                        '即可升级' +
                        activitylist[index < activitylist.length - 1 ? index + 1 : index].level
                  }}
                </span>
              </div>
              <div class="flex jc-sb" :class="[old == 1 ? 'mt8 ai-c' : 'scoped_mt-14 ai-fe']">
                <div
                  class="speed pos-r"
                  :class="[old == 1 ? 'radius-10px' : 'radius-6px']"
                  id="1"
                  v-if="parseFloat(info.vip_money) < parseFloat(activitylist[index].money)"
                  :style="
                    index == activitylist.length - 1
                      ? { background: 'rgba(255, 255, 255, 0.1)' }
                      : {}
                  "
                >
                  <sub :class="[old == 1 ? 'f16' : 'f10']">L{{ info.vip_level_value }}</sub>
                  <div
                    class="start"
                    :class="[old == 1 ? 'radius-10px' : 'radius-6px']"
                    :style="{
                      width:
                        (parseFloat(info.vip_money) / parseFloat(activitylist[index].money)) * 100 -
                        13 +
                        '%'
                    }"
                  ></div>
                  <sup :class="[old == 1 ? 'f16' : 'f10']">
                    L{{ activitylist[index].levelvalue }}
                  </sup>
                </div>
                <div
                  class="speed pos-r"
                  :class="[old == 1 ? 'radius-10px' : 'radius-6px']"
                  id="2"
                  v-else-if="
                    (info.vip_level_value == item.levelvalue || info.vip_money == item.money) &&
                    parseFloat(info.vip_money) <
                      parseFloat(
                        activitylist[index < activitylist.length - 1 ? index + 1 : index].money
                      )
                  "
                  :style="
                    index == activitylist.length - 1
                      ? { background: 'rgba(255, 255, 255, 0.1)' }
                      : {}
                  "
                >
                  <sub :class="[old == 1 ? 'f16' : 'f10']">L{{ info.vip_level_value }}</sub>
                  <div
                    class="start"
                    :class="[old == 1 ? 'radius-10px' : 'radius-6px']"
                    :style="{
                      width:
                        (parseFloat(info.vip_money) /
                          parseFloat(
                            activitylist[index < activitylist.length - 1 ? index + 1 : index].money
                          )) *
                          100 -
                        13 +
                        '%'
                    }"
                  ></div>
                  <sup :class="[old == 1 ? 'f16' : 'f10']">
                    L{{
                      activitylist[index < activitylist.length - 1 ? index + 1 : index].levelvalue
                    }}
                  </sup>
                </div>
                <button
                  :class="[old == 1 ? 'f18' : 'f14']"
                  @click="upgrade"
                  v-if="
                    info.vip_level_value <= activitylist[index].levelvalue &&
                    parseFloat(info.vip_money) <= activitylist[index].money
                  "
                  :style="
                    index == activitylist.length - 1
                      ? { background: 'rgba(255, 255, 255, 0.1)' }
                      : {}
                  "
                >
                  去升级
                </button>
                <button
                  class="f14"
                  :class="[old == 1 ? 'f18' : 'f14']"
                  @click="upgrade"
                  v-else-if="
                    info.vip_level_value == activitylist[index].levelvalue &&
                    parseFloat(info.vip_money) <=
                      activitylist[index < activitylist.length - 1 ? index + 1 : index].money
                  "
                  :style="
                    index == activitylist.length - 1
                      ? { background: 'rgba(255, 255, 255, 0.1)' }
                      : {}
                  "
                >
                  去升级
                </button>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="flex-js-ac title">
      <p :class="[old == 1 ? 'f22' : 'f11']">
        {{
          info.vip_level_value > activitylist[activeIndex].levelvalue
            ? 'L' + activitylist[activeIndex].levelvalue + '专属权益'
            : info.vip_level_value == activitylist[activeIndex].levelvalue
            ? '我的专属权益'
            : '升级后即可享受'
        }}
      </p>
      <div class="color-9" :class="[old == 1 ? 'f19' : 'f12']" @click="instructions">
        查看会员等级说明
        <van-icon :size="old == 1 ? '0.19rem' : '0.12rem'" color="#999999" name="arrow" />
      </div>
    </div>
    <ul class="equity flex-w">
      <li v-for="item of activitylist[activeIndex].privilege" @click="goequity(item)">
        <img :src="item[old == 1 ? 'oldimgurl' : 'imgurl']" />
      </li>
    </ul>
    <div
      id="upgrade"
      style="margin-top: 0.1rem; background: #fff; padding: 0 0.11rem"
      v-if="productlist && productlist.length > 0"
    >
      <div class="flex-js-ac title" style="padding: 0.14rem 0 0.06rem">
        <p class="f18" :class="[old == 1 ? 'f22' : 'f18']">
          我要升级
          <span v-if="upgradehint" class="color-9" :class="[old == 1 ? 'f15' : 'f14']">
            {{ '(' + upgradehint + ')' }}
          </span>
        </p>
      </div>
      <product-list
        :old="old"
        :productlist="productlist"
        :markPointData="{ scenepoint: 'MEMBERCENTER' }"
      ></product-list>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import productList from '../common/productList'
export default {
  name: 'vipCenter',
  components: {
    productList
  },
  data() {
    var that = this
    return {
      info: null,
      activitylist: [],
      old_activitylist: [],
      activeIndex: 0,
      activitySwiper: {
        // width: 330,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // slidesOffsetBefore: 105,
        // slidesOffsetAfter: 108,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        slidesPerView: 1.47,
        slidesPerGroup: 1,
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.realIndex
            sessionStorage.setItem('vipCenter_activeIndex', String(that.activeIndex))
          },
          click: function () {}
        }
      },
      icon: [],
      productlist: [],
      upgradehint: '',
      old: -1
    }
  },
  mounted: function () {
    this.old = this.$route.query.old || 0
    this.getData()
    this.recommentFn()
  },
  computed: {
    myswiper() {
      return this.$refs.myswiper.swiper
    }
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getIndex_Member_URL
      this.upgradehint = ''
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.info = res.data
          this.activitylist = res.data.vip_levellist
          this.old_activitylist = res.data.vip_levellist_old || []
          this.icon = res.data.privilege
          try {
            this.activitylist.map((item, index) => {
              if (
                parseInt(item.levelvalue) >= parseInt(this.info.vip_level_value) ||
                parseFloat(item.money) > parseFloat(this.info.vip_money)
              ) {
                if (
                  parseFloat(
                    this.activitylist[index < this.activitylist.length - 1 ? index + 1 : index]
                      .money
                  ) > parseFloat(this.info.vip_money)
                ) {
                  this.upgradehint = `还差￥${(
                    parseFloat(
                      this.activitylist[index < this.activitylist.length - 1 ? index + 1 : index]
                        .money
                    ) - parseFloat(this.info.vip_money)
                  ).toFixed(2)}，升级到${
                    this.activitylist[index < this.activitylist.length - 1 ? index + 1 : index]
                      .level
                  }`
                }
                throw new Error('终止遍历')
              }
            })
          } catch (e) {
            console.log('出错啦')
          }
          this.$nextTick(function () {
            if (sessionStorage.getItem('vipCenter_activeIndex')) {
              this.activeIndex = Number(sessionStorage.getItem('vipCenter_activeIndex'))
              this.myswiper.slideTo(Number(this.activeIndex), 0, true)
            } else {
              this.activeIndex = Number(this.info.vip_level_value)
              sessionStorage.setItem('vipCenter_activeIndex', String(this.activeIndex))
              this.myswiper.slideTo(Number(this.activeIndex), 500, false)
            }
          })
        }
      })
    },
    recommentFn: function () {
      var recommentUrl = this.$ajax.getRecommendByShoppingCart_URL
      this.$customRequestAjax(recommentUrl).then((res) => {
        if (res.data.code == 200) {
          this.productlist = res.data.itemlist
        }
      })
    },
    goequity: function (item) {
      if (item.gifttype == 1) {
        this.$app.argStaticLink(
          '/static/wx/html/privilegesDetails/IdentifyQrCode.html?tagid=' + item.tagid
        )
      } else if (item.gifttype == 2 || item.gifttype == 4 || item.gifttype == 5) {
        this.$app.argStaticLink(
          '/static/wx/html/privilegesDetails/vipRights.html?tagid=' +
            item.tagid +
            '&gifttype=' +
            item.gifttype
        )
      } else if (item.gifttype == 3) {
        this.$app.argStaticLink(
          '/static/wx/html/privilegesDetails/specialOfferCommodity.html?id=' +
            item.id +
            '&pagefrom=vipcenter'
        )
      } else if (item.link) {
        if (this.activitylist[this.activeIndex].levelvalue == this.info.vip_level_value) {
          this.$app.argStaticLink(item.link)
        } else {
          this.$toast('您还不能享受此权益！')
        }
      }
    },
    instructions: function () {
      this.$app.argLink({ path: '/instructions' })
    },
    // 升级
    upgrade: function () {
      var that = this
      setTimeout(function () {
        that.jump(document.querySelectorAll('#upgrade'))
      })
    },
    // 点击滚动
    jump: function (dom) {
      var jump = dom
      var total = jump[0].offsetTop - 10
      var distance =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      if (total > distance) {
        smoothDown()
      } else {
        smoothUp()
      }
      function smoothDown() {
        var step = total / 5
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        var newTotal = distance - total
        var step = newTotal / 5
        if (distance > 0) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vipcenter {
  .activity {
    padding-top: 0.1rem;
    background: #ffffff;
    /*height: 2.16rem;*/
    width: 100%;
    overflow: hidden;
    .swiper-container {
      width: 128%;
      margin-left: -14%;
    }

    .swiper-slide .main-img {
      width: 100%;
      height: 1.8rem;
      margin: 0 auto;
      display: block;
      border-radius: 0.08rem;
      transition: all 0.3s;
    }
    .swiper-slide {
      transform: scale(0.9);
      transition: all 0.2s ease-in 0s;
      border-top-left-radius: 0.07rem;
      border-top-right-radius: 0.07rem;
      .vipcard_content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        .tag {
          border-radius: 0.15rem 0 0.08rem 0;
          background: rgba(0, 0, 0, 0.15);
          min-width: 0.58rem;
        }
        .vip_title {
          margin-top: 0.15rem;
          margin-bottom: 0.08rem;
        }
        .plan {
          margin-top: 0.23rem;
          margin-right: 0.23rem;
          .speed {
            background: rgba(0, 0, 0, 0.1);
            width: 1.45rem;
            height: 0.11rem;
            .start {
              position: absolute;
              left: 0.01rem;
              top: 0.01rem;
              height: 0.09rem;
              min-width: 10%;
              background: #ffffff;
              border-radius: 0.06rem;
              z-index: 1;
            }
            sub {
              color: #a9afb9;
              left: 0.02rem;
            }
            sup {
              color: #ffffff;
              right: 0.02rem;
            }
            sub,
            sup {
              transform: scale(0.7);
              line-height: 0.11rem;
              position: absolute;
              top: 0;
              z-index: 2;
            }
          }
          button {
            background: rgba(0, 0, 0, 0.15);
            color: #ffffff;
            border-radius: 0.16rem;
            border-width: 0;
            outline: none;
            width: 0.81rem;
            height: 0.32rem;
            line-height: 0.32rem;
            text-align: center;
          }
        }
      }
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
      border-top-left-radius: 0.04rem;
      border-top-right-radius: 0.04rem;
    }
  }
  .title {
    background: #ffffff;
    padding: 0.16rem 0.11rem 0;
  }
  .equity {
    background: #ffffff;
    display: flex;
    padding: 0.1rem;
    li {
      width: 33.3%;
      img {
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
.scoped_mt-14 {
  margin-top: -0.14rem !important;
}
.vipcenter.old_vipcenter {
  .activity {
    .swiper-slide {
      .main-img {
        height: 2.08rem;
      }
      .vipcard_content {
        .vip_title {
          margin-top: 0.13rem;
        }
        .plan {
          .speed {
            height: 0.17rem;
            .start {
              height: 0.15rem;
              min-width: 13%;
            }
          }
          button {
            width: 0.9rem;
            height: 0.36rem;
            border-radius: 0.18rem;
          }
          sub,
          sup {
            line-height: 0.16rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/vipCenter.vue